import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CoreProvider } from '../../providers/core-service/core-service';

import { Week } from "../../model/Week";
import { User } from "../../model/user";
import { Subscription } from 'rxjs/Subscription';

import { legendaStati } from './../../constants/constants';
import { DatePipe } from '@angular/common';

import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

/**
 * Generated class for the WebFilterViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-web-filter-view',
  templateUrl: 'web-filter-view.html',
})
export class WebFilterViewPage {

  //activeFilterIndex: number = -1;
  activeFilterIndexes: number[];

  user = {
    name: '',
    title: '',
    photo: ''
  };

  pageActive = 'filter';

  halfDayHeadquarter: any[] = [];
  halfDayTravel: any[] = [];
  halfDayLeave: any[] = [];
  halfDayBankHoliday: any[] = [];

  showNav = false;
  is_online = true;
  show_loading = true;

  currentDate: Date = new Date();
  // Initialized to specific date (09.10.2018).
  currentDatePick: any = { date: { year: this.currentDate.getFullYear(), month: this.currentDate.getMonth(), day: this.currentDate.getDate() } };
  currentDateDay: string = new DatePipe("en").transform(new Date(this.currentDate), 'd MMM y');
  currentDateText: string;
  halfIndex: string;
  week_range: [Date, Date];
  week_differ: number = 0;
  week_binding: Week[] = [];

  weeksbinding: Subscription;

  prevShow: boolean = true;
  nextShow: boolean = true;

  myDatePickerOptions: IMyDpOptions = {
    // other options...
    todayBtnTxt: 'Today',
    dateFormat: 'd MMM y',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    showClearDateBtn: false,
    showInputField: false,
    inline: false,
  };

  userListToShow: User[] = [];

  private onNext = true;
  private onPrev = true;
  private checkNextOnce = false;
  private checkPrevOnce = false;

  querying = false;
  showAutocomplete = false;
  showTravelEvidence = true;
  querySearch = '';
  autocomplete = [];
  manager = [];
  places = [];

  onlyTravel: boolean = false;
  resultsEmpty: boolean = false;

  searchSubmit = false;
  halfDayHeadquarterPublish: number = 0;
  halfDayLeavePublish: number = 0;
  halfDayBankHolidayPublish: number = 0;
  halfDayTravelPublish: number = 0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private coreService: CoreProvider,
  ) {
    this.week_range = this.coreService.getWeekRange();

    this.activeFilterIndexes = [];

    let limitDatePrev = this.coreService.getPrevWeekNumber(this.coreService.configuration.number_of_week_visible_in_precedence);
    //console.log(limitDatePrev);
    let limitDateNext = this.coreService.getNextWeekNumber(this.coreService.configuration.number_of_week_visible_in_advance);
    //console.log(limitDateNext);

    this.myDatePickerOptions = {
      // other options...
      todayBtnTxt: 'Today',
      dateFormat: 'd MMM y',
      firstDayOfWeek: 'mo',
      sunHighlight: true,
      showClearDateBtn: false,
      showInputField: false,
      inline: false,
      disableUntil: { year: limitDatePrev.getFullYear(), month: limitDatePrev.getMonth() + 1, day: limitDatePrev.getDate() },
      disableSince: { year: limitDateNext.getFullYear(), month: limitDateNext.getMonth() + 1, day: limitDateNext.getDate() }
    };
  }

  ionViewWillEnter() {

    if (this.navParams.get('activeIndex')) {
      //this.activeFilterIndex = this.navParams.get('activeIndex');
      this.activeFilterIndexes = this.navParams.get('activeIndex');
    }

    let resetDate = this.navParams.get('resetDate');

    if (resetDate) {
      this.coreService.setSearchedData(null);
      this.coreService.resetWeekPointer(true);
    }

    this.coreService.getUserData().filter(x => x).subscribe(user => {
      //console.log('autenticato: ' + user.key);
      //console.log(user);

      if (user) {
        this.user = user;
      }
    });

    this.setCorrectDate();

    //this.week_range = firebase.getWeekRange();
    this.weeksbinding = this.coreService.getWeek().subscribe(week => {
      this.setCorrectDate();

      if (this.onNext && !this.checkNextOnce) {
        this.checkNextOnce = true;
        this.coreService.getofflineNextHalfDay().then(result => {
          this.nextShow = result;
        });
      }

      if (this.onPrev && !this.checkPrevOnce) {
        this.checkPrevOnce = true;
        this.coreService.getofflinePrevHalfDay().then(result => {
          this.prevShow = result;
        });
      }

      this.week_binding = week;
      this.week_range = this.coreService.getWeekRange();

      this.mantainResearch();

    });

  }

  ionViewWillLeave() {
    // enable the root left menu when leaving this page
    this.weeksbinding.unsubscribe();
  }

  showNavBar() {
    this.showNav = true;
  }

  closeNav() {
    this.showNav = false;
  }

  // dateChanged callback function called when the user select the date. This is mandatory callback
  // in this option. There are also optional inputFieldChanged and calendarViewChanged callbacks.
  onDateChanged(event: IMyDateModel) {
    // event properties are: event.date, event.jsdate, event.formatted and event.epoc
    //console.log(event);
    this.coreService.repointerWeek(event.jsdate);
  }

  /**
   * Genera l'oggetto da visualizzare nella vista con i campi personalizzati
   * @param week 
   */
  generateElementData(week: Week): any {
    return {
      name: week.user.name,
      label: week[this.halfIndex],
      notes: week[this.halfIndex + '_note'],
      title: week.user.title,
      photo: week.user.photo,
      key: week.user.key,
      show: week.show,
      confirmed: week.confirmed ? week.confirmed : false
    };
  }

  /**
   * Genera le liste per i diversi filtri a partire dalla settimana
   */
  generateHalfDayWeek() {

    this.halfDayHeadquarter = [];
    this.halfDayLeave = [];
    this.halfDayBankHoliday = [];
    this.halfDayTravel = [];

    this.halfDayHeadquarterPublish = 0;
    this.halfDayLeavePublish = 0;
    this.halfDayBankHolidayPublish = 0;
    this.halfDayTravelPublish = 0;

   // console.log(this.halfIndex);
    for (let userweek of this.week_binding) {
      //console.log(userweek[this.halfIndex].toLowerCase());
      if (!userweek[this.halfIndex])
        continue;
      if (userweek[this.halfIndex].toLowerCase() == legendaStati[0].toLowerCase()) { //Headquarter
        this.halfDayHeadquarter.push(this.generateElementData(userweek));
        if (userweek.show)
          this.halfDayHeadquarterPublish = this.halfDayHeadquarterPublish + 1;
      } else if (this.coreService.getLeaveLabel().indexOf(userweek[this.halfIndex]) > -1) { //Leave Sickness 
        this.halfDayLeave.push(this.generateElementData(userweek));
        if (userweek.show)
          this.halfDayLeavePublish = this.halfDayLeavePublish + 1;
      } else if (userweek[this.halfIndex].toLowerCase() == legendaStati[1].toLowerCase()) { //Bank Holiday
        this.halfDayBankHoliday.push(this.generateElementData(userweek));
        if (userweek.show)
          this.halfDayBankHolidayPublish = this.halfDayBankHolidayPublish + 1;
      } else {
        this.halfDayTravel.push(this.generateElementData(userweek));
        if (userweek.show)
          this.halfDayTravelPublish = this.halfDayTravelPublish + 1;
      }
    }

    if (this.isQuerying()) {
      if (this.halfDayHeadquarterPublish > 0)
        this.openFilterAccordion(0);
      else
        this.closeFilterAccordion(0);

      if (this.halfDayLeavePublish > 0)
        this.openFilterAccordion(2);
      else
        this.closeFilterAccordion(2);

      if (this.halfDayBankHolidayPublish > 0)
        this.openFilterAccordion(3);
      else
        this.closeFilterAccordion(3);

      if (this.halfDayTravelPublish > 0)
        this.openFilterAccordion(1);
      else
        this.closeFilterAccordion(1);
    }
  }

  /**
   * Controlla se indice attivo
   */
  showIndex(index: number): boolean {

    if (this.isQuerying() && this.searchSubmit) {
      if (this.onlyTravel) {
        if (index == 1)
          return true;
        else
          return false;
      } else {

        if (index == 0 && this.halfDayHeadquarterPublish == 0)
          return false;

        if (index == 1 && this.halfDayTravelPublish == 0)
          return false;

        if (index == 2 && this.halfDayLeavePublish == 0)
          return false;

        if (index == 3 && this.halfDayBankHolidayPublish == 0)
          return false;
      }
    }

    return true;

  }

  /**
   * Controlla se indice attivo
   */
  activeIndexes(index: number): boolean {
    for (let indexActive of this.activeFilterIndexes) {
      if (index == indexActive) {
        return true;
      }
    }
    return false;
  }

  /**
   * Apre/Chiude l'accordion selezionato
   * @param index indice su array stateArray
   */
  openFilterAccordion(index: number): void {

    let found = false;

    for (let indexActive of this.activeFilterIndexes) {
      if (index == indexActive) {
        found = true;
      }
    }

    if (!found) {
      this.activeFilterIndexes.push(index);
    }
  };

  /**
   * Apre/Chiude l'accordion selezionato
   * @param index indice su array stateArray
   */
  closeFilterAccordion(index: number): void {

    let found = false;
    let arrayIndexesPurge = [];

    for (let indexActive of this.activeFilterIndexes) {
      if (index == indexActive) {
        found = true;
      } else {
        arrayIndexesPurge.push(indexActive);
      }
    }

    if (found) {
      this.activeFilterIndexes = arrayIndexesPurge;
    }
  };

  /**
   * Apre/Chiude l'accordion selezionato
   * @param index indice su array stateArray
   */
  toggleFilterAccordion(index: number): void {

    let found = false;
    let arrayIndexesPurge = [];

    for (let indexActive of this.activeFilterIndexes) {
      if (index == indexActive) {
        found = true;
      } else {
        arrayIndexesPurge.push(indexActive);
      }
    }

    if (found) {
      this.activeFilterIndexes = arrayIndexesPurge;
    } else {
      this.activeFilterIndexes.push(index);
    }
  };

  /**
   * Aggiorna la data visualizzata e l'indice della mezza giornata
   */
  setCorrectDate() {
    let tuple_day = this.coreService.getHalfDayIndex();
    this.halfIndex = tuple_day[0];
    //console.log(this.halfIndex);
    this.currentDateText = tuple_day[1];
    this.currentDate = new Date(this.coreService.getCurrentDate());
    this.currentDateDay = new DatePipe("en").transform(new Date(this.currentDate), 'd MMM. y');
    this.currentDatePick = { date: { year: this.currentDate.getFullYear(), month: this.currentDate.getMonth(), day: this.currentDate.getDate() } };
  }

  /**
   * Visualizza lo stato della settimana
   * @param key indice utente
   */
  checkUserPermission(key: string): boolean {

    if (this.coreService.userData.role == "hr") return true;

    if (this.coreService.userKey == key) return true;

    if (this.coreService.userData.delegations && this.coreService.userData.delegations.indexOf(key) > -1) return true;

    return false;
  }

  /**
   * Visualizza lo stato della settimana
   * @param key indice utente
   */
  checkUserViewConfirm(key: string): boolean {

    if (this.coreService.userData.role == "hr") return true;

    if (this.coreService.userKey == key) return true;

    if (this.coreService.userData.delegations && this.coreService.userData.delegations.indexOf(key) > -1) return true;

    return false;
  }

  /** */
  nextHalfDay(): void {
    this.prevShow = true;
    if (this.coreService.getNextHalfDay()) {
      this.setCorrectDate();
      this.generateHalfDayWeek();
      this.coreService.getofflineNextHalfDay().then(result => {
        this.nextShow = result;

        this.mantainResearch();
      });
    } else {
      this.onNext = true;
      this.checkNextOnce = false;
    }
  }

  /** */
  prevHalfDay(): void {
    this.nextShow = true;
    if (this.coreService.getPrevHalfDay()) {
      this.setCorrectDate();
      this.generateHalfDayWeek();
      this.coreService.getofflinePrevHalfDay().then(result => {
        this.prevShow = result;

        this.mantainResearch();
      });
    } else {
      this.onPrev = true;
      this.checkPrevOnce = false;
    }
  }

  /**
   * Funzione autocompletamento
   * @param query stringa ricercata
   * {"autocomplete": ["Marcat Siro"], "managers": {"Marcat Siro": "year/2018/6/siromarcat@gmailcom"}, "places": {}}
   * {"autocomplete": ["Padua", "Padova"], "managers": {}, "places": {"Padua": ["year/2018/6/ggiorgianni@demogoreplyio/1_am"], "Padova": ["year/2018/6/ggiorgianni@demogoreplyio/1_am"]}}
   */
  onChange(query: string) {
    if (query.length > 2) {
      this.coreService.getAutocompleteSearchValuesFilter(query).first().subscribe(result => {
        //this.autocomplete = result.autocomplete;

        this.showAutocomplete = true;
        this.autocomplete = result.autocomplete;

        this.manager = result.managers;
        this.places = result.places;
      });
    } else {
      this.showAutocomplete = false;
      this.autocomplete = [];

      this.manager = [];
      this.places = [];
    }
  }

  /**
   * Controlla se la ricerca è attiva
   */
  isQuerying(): boolean {
    if (this.querySearch.length > 0) {
      return true;
    }

    //this.searchedPlace = '';
    return this.querying;
  }

  /**
   * Salva indice autocomplete per ricera
   */
  setSearchQuery(txt: string) {
    this.querySearch = txt;

    this.showAutocomplete = false;

    this.submitSearch();
    //this.keyboard.close();
  }

  /**
   * Resetta campo ricerca
   */
  resetSearch() {
    this.querySearch = '';
    this.autocomplete = [];
    this.manager = [];
    this.places = [];
    this.coreService.setSearchedData(null);

    this.onlyTravel = false;
    this.resultsEmpty = false;

    this.querying = false;
    this.showAutocomplete = false;

    this.resetWeekVisible();
  }

  /**
   * Invia la ricera
   */
  submitSearch() {
    if (this.querySearch.length > 2) {
      this.showTravelEvidence = true;
      this.showAutocomplete = false;

      this.querying = true;

      this.coreService.setSearchedData(null);
      this.mantainResearch();

    } else {

      this.querying = false;
      this.showAutocomplete = false;
      this.autocomplete = [];
      this.manager = [];
      this.places = [];
      this.onlyTravel = false;

      this.coreService.setSearchedData(null);
      this.resetWeekVisible();
    }
  }

  /**
   * Mantiene la ricera nello spostamento tra settimane
   */
  mantainResearch() {
    let findOnAutocomplete = false;
    let elementFind: string[] = [];

    let searchedData = null;
    searchedData = this.coreService.getSearchedData();

    if (searchedData) {
      //ricerca settata

      let type = searchedData.type;
      this.querySearch = searchedData.query;

      if (type == 0) {
        this.setWeekVisible(searchedData.elements);

      } else if (type == 1) {
        this.coreService.getAutocompleteSearchValuesFilter(this.querySearch).first().subscribe(result => {
          this.showTravelEvidence = true;
          this.places = result.places;

          elementFind = [];
          if (this.places && (this.querySearch in this.places))
            for (let place of this.places[this.querySearch]) {

              let userkey = place.split('/')[3];
              //let index = place.split('/')[4];

              let element_exist = false;
              for (let exist of elementFind) {
                if (exist == userkey) {
                  element_exist = true;
                  break;
                }
              }

              if (!element_exist) {
                elementFind.push(userkey);
              }

              findOnAutocomplete = true;
            }

          elementFind.sort();

          this.setWeekVisible(elementFind, this.showTravelEvidence);
        });
      } else if (type == 2) {
        this.coreService.getAutocompleteSearchGeneric(this.querySearch, true).toPromise().then(results => {
          elementFind = [];

          for (let user of results) {
            let userkey = user.split('/')[3];

            let element_exist = false;
            for (let exist of elementFind) {
              if (exist == userkey) {
                element_exist = true;
                break;
              }
            }

            if (!element_exist) {
              elementFind.push(userkey);
            }
          }

          if (elementFind.length == 0) {
            this.setWeekVisible([]);
          } else {
            this.setWeekVisible(elementFind);
          }

        }).catch();
      }

    } else {

      //lanciare autocomplete per riottenere lista utenti da visualizzare con lista index per utente array
      if (this.querySearch.length > 0) {
        if (this.manager[this.querySearch]) {

          //se manager taglia le prime n lettere
          let userkey = this.manager[this.querySearch].split('/')[3];
          elementFind.push(userkey);
          findOnAutocomplete = true;

          this.coreService.setSearchedData({
            type: 0,
            query: this.querySearch,
            elements: elementFind
          });

          this.setWeekVisible(elementFind);

        } else if (this.places[this.querySearch]) {

          for (let place of this.places[this.querySearch]) {

            let userkey = place.split('/')[3];
            //let index = place.split('/')[4];

            let element_exist = false;
            for (let exist of elementFind) {
              if (exist == userkey) {
                element_exist = true;
                break;
              }
            }
            

            if (!element_exist) {
              elementFind.push(userkey);
            }

            findOnAutocomplete = true;
          }

          elementFind.sort();
          
          //console.log(elementFind);

          this.coreService.setSearchedData({
            type: 1,
            query: this.querySearch
          });

          // this.activeFilterIndex = 1;
          this.activeFilterIndexes = [];
          this.activeFilterIndexes.push(1);

          this.onlyTravel = true;
          this.setWeekVisible(elementFind, this.showTravelEvidence);

        } else {


          this.coreService.getAutocompleteSearchGeneric(this.querySearch, true).toPromise().then(results => {

            for (let user of results) {
              let endpoint = user.split('/')[3];
              let userkey = endpoint.split('/')[0];

              let element_exist = false;
              for (let exist of elementFind) {
                if (exist == userkey) {
                  element_exist = true;
                  break;
                }
              }

              if (!element_exist) {
                elementFind.push(userkey);
              }
            }

            this.coreService.setSearchedData({
              type: 2,
              query: this.querySearch,
              elements: elementFind
            });

            if (elementFind.length == 0) {
              this.setWeekVisible([]);
            } else {
              this.setWeekVisible(elementFind);
            }
          }).catch();

        }
        //se place taglia le prime n lettere e mantiene valore key e mezza giornata se da evidenziare
        //console.log(elementFind);

      } else {

        this.resetWeekVisible();
      }

    }
  }

  /**
   * Filtra la settimana e nasconde gli utenti non desiderati
   */
  setWeekVisible(userList: string[], travelOnly: boolean = false) {
    this.searchSubmit = true;

    if (this.isQuerying()) {
      //console.log(userList);
      if (userList.length == 0)
        this.resultsEmpty = true;
      else
        this.resultsEmpty = false;
    } else {
      this.resultsEmpty = false;
    }

    //console.log(userList);
    if (!travelOnly) {
      for (let week of this.week_binding) {
        week.show = false;
        for (let user of userList) {
          if (user == week.user.key) {
            week.show = true;
          }
        }
      }
    } else {
      for (let week of this.week_binding) {
        week.show = false;
        for (let user of userList) {
          if (user == week.user.key) {

            week.show = true;
            break;
          }
        }
      }
    }

    //console.log(this.week_binding);
    this.generateHalfDayWeek();
  }

  resetWeekVisible() {
    this.resultsEmpty = false;
    this.searchSubmit = false;

    if (this.week_binding.length > 0) {
      for (let week of this.week_binding) {
        week.show = true;
      }
      // console.log('reset week');
    }

    this.generateHalfDayWeek();
  }
}



// WEBPACK FOOTER //
// ./src/pages/web-filter-view/web-filter-view.ts